export const dessin = [
  { text: 'Edges: Finished', value: '3' },
  { text: 'Edges: Open', value: '4' },
  { text: 'Fringes/Kelim: Like Original', value: '5' },
  { text: 'Fringes: Yes', value: '1' },
  { text: 'Fringes: No', value: '2' },
  { text: 'Kelim', value: '6' },
  { text: 'With Tassels', value: '7' },
  { text: 'Without Tassels', value: '8' },
]

export const producer = [
  { text: 'ASHA', value: 'ASHA' },
  { text: 'BML', value: 'BML' },
  { text: 'Carpet Maker', value: 'CMAKE' },
  { text: 'Dema', value: 'DEMA' },
  { text: 'FER', value: 'FER' },
  { text: 'HAN', value: 'HAN' },
  { text: 'Home Tex India', value: 'HTI' },
  { text: 'Hospitality', value: 'HOS' },
  { text: 'JIGME', value: 'JIGME' },
  { text: 'KAJU', value: 'KAJU' },
  { text: 'KAR', value: 'KAR' },
  { text: 'KCM', value: 'KCM' },
  { text: 'KIS', value: 'KIS' },
  { text: 'KVC', value: 'KVC' },
  { text: 'LMB', value: 'LMB' },
  { text: 'MOR', value: 'MOR' },
  { text: 'RKI', value: 'RKI' },
  { text: 'SIAM', value: 'SIAM' },
  { text: 'SIGMA', value: 'SIGMA' },
  { text: 'TRE', value: 'TRE' },
  { text: 'VCM', value: 'VCM' },
  { text: 'Woven Legends', value: 'WL' },
]

export const quality = [
  // Nepal
  { text: '40 Knot', value: '40' },
  { text: '60 Knot', value: '60' },
  { text: '60 Knot, Short Pile', value: '6SP' },
  { text: '80 Knot', value: '80' },
  { text: '80 Knot, Short Pile', value: '8SP' },
  { text: 'S. 80 Knot', value: 'S80' },
  { text: 'S. 80 Knot, Short Pile', value: 'SS8' },
  { text: '100 Knot', value: '100' },
  { text: '100 Knot, Drokba', value: '10D' },
  { text: '100 Knot, Short Pile', value: 'SS1' },
  { text: '150 Knot', value: '150' },
  { text: '200 Knot', value: '200' },
  { text: '300 Knot', value: '300' },
  { text: '400 Knot', value: '400' },
  { text: '450 Knot', value: '450' },
  { text: 'Kelim', value: 'KEL' },
  { text: 'Loose Shag', value: 'LS' },
  { text: 'Loose Weave', value: 'LW' },
  { text: 'Moroc. Weave', value: 'MW' },
  // Ashu
  { text: '7x7 Knot', value: '7X7' },
  { text: '8x10', value: '810' },
  { text: '11x11 Knot', value: '11X' },
  { text: '16x16 Knot', value: '16' },
  { text: '18x18 Knot', value: '18X' },
  { text: 'Mahal Weave', value: 'MAH' },
  { text: 'Fine Mahal Weave', value: 'FMW' },
  // Tuft
  { text: 'HT 350', value: 'H35' },
  { text: 'HT 400', value: 'H40' },
  { text: 'HT 450', value: 'H45' },
  { text: 'HT 500', value: 'H50' },
  { text: 'HT 550', value: 'H55' },
  { text: 'HT 600', value: 'H60' },
  { text: 'HT 650', value: 'H65' },
  { text: 'HT 700', value: 'H70' },
  { text: 'HT 750', value: 'H75' },
  { text: 'HT 800', value: 'H80' },
  { text: 'HT 850', value: 'H85' },
  { text: 'MT 350', value: 'M35' },
  { text: 'MT 450', value: 'M45' },
  { text: 'MT 500', value: 'M50' },
  { text: 'MT 550', value: 'M55' },
  { text: 'MT 750', value: 'M75' },
  { text: 'High Resilience', value: 'HR' },
  // Other
  { text: '120 Knot', value: '120' },
  { text: '100 Knot Short Pile', value: '1SP' },
  { text: '24x24 Knot', value: '24' },
  { text: '250 Knot', value: '250' },
  { text: '80 Knot Special', value: '80S' },
  { text: 'Berber', value: 'BER' },
  { text: 'BK', value: 'BK' },
  { text: 'S80 Knot Short Pile HC', value: 'E15' },
  { text: 'S80 Knot/100 Knot', value: 'M1' },
  { text: '60 Knot/100 Knot', value: 'M2' },
  { text: 'Machine Tuft', value: 'MT' },
  { text: 'S. 60 Knot', value: 'S60' },
  { text: 'Shaggy', value: 'SHA' },
  { text: 'Tuft', value: 'TFT' },
]

export const status = [
  { text: 'In Stock', value: 'INSTOCK' },
  { text: 'Confirmed', value: 'RESERVED' },
  { text: 'Knotting', value: 'KNOTTING' },
  { text: 'On Consignment', value: 'CONSIGNMENT' },
  { text: 'Sold', value: 'SOLD' },
  { text: 'Unknown', value: 'UNKNOWN' },
]
